import { Record } from "./fable_modules/fable-library-js.4.17.0/Types.js";
import { anonRecord_type, bool_type, array_type, float64_type, option_type, record_type, int32_type, string_type } from "./fable_modules/fable-library-js.4.17.0/Reflection.js";

export class TopShortEntry extends Record {
    constructor(Ticker, Market, Name, Percentage, ShortDate) {
        super();
        this.Ticker = Ticker;
        this.Market = Market;
        this.Name = Name;
        this.Percentage = (Percentage | 0);
        this.ShortDate = ShortDate;
    }
}

export function TopShortEntry_$reflection() {
    return record_type("Types.TopShortEntry", [], TopShortEntry, () => [["Ticker", string_type], ["Market", string_type], ["Name", string_type], ["Percentage", int32_type], ["ShortDate", string_type]]);
}

export class ShortEvent extends Record {
    constructor(Date$, Ticker, Market, Name, ChangePercent, OldPercent, NewPercent) {
        super();
        this.Date = Date$;
        this.Ticker = Ticker;
        this.Market = Market;
        this.Name = Name;
        this.ChangePercent = ChangePercent;
        this.OldPercent = OldPercent;
        this.NewPercent = (NewPercent | 0);
    }
}

export function ShortEvent_$reflection() {
    return record_type("Types.ShortEvent", [], ShortEvent, () => [["Date", string_type], ["Ticker", string_type], ["Market", string_type], ["Name", string_type], ["ChangePercent", option_type(int32_type)], ["OldPercent", option_type(int32_type)], ["NewPercent", int32_type]]);
}

export class ReviewMeta extends Record {
    constructor(Id, Ticker, Market, Asset, Rating, Username) {
        super();
        this.Id = (Id | 0);
        this.Ticker = Ticker;
        this.Market = Market;
        this.Asset = Asset;
        this.Rating = Rating;
        this.Username = Username;
    }
}

export function ReviewMeta_$reflection() {
    return record_type("Types.ReviewMeta", [], ReviewMeta, () => [["Id", int32_type], ["Ticker", string_type], ["Market", string_type], ["Asset", string_type], ["Rating", string_type], ["Username", string_type]]);
}

export class InsiderTradeEvent extends Record {
    constructor(Id, Date$, Ticker, Market, Name, NumShares) {
        super();
        this.Id = (Id | 0);
        this.Date = Date$;
        this.Ticker = Ticker;
        this.Market = Market;
        this.Name = Name;
        this.NumShares = (NumShares | 0);
    }
}

export function InsiderTradeEvent_$reflection() {
    return record_type("Types.InsiderTradeEvent", [], InsiderTradeEvent, () => [["Id", int32_type], ["Date", string_type], ["Ticker", string_type], ["Market", string_type], ["Name", string_type], ["NumShares", int32_type]]);
}

export class InsiderTradeExchangeInfo extends Record {
    constructor(AvgPrice, Currency) {
        super();
        this.AvgPrice = AvgPrice;
        this.Currency = Currency;
    }
}

export function InsiderTradeExchangeInfo_$reflection() {
    return record_type("Types.InsiderTradeExchangeInfo", [], InsiderTradeExchangeInfo, () => [["AvgPrice", float64_type], ["Currency", string_type]]);
}

export class PostInsiderInfo extends Record {
    constructor(Insider, NumShares, Date$, AvgPrice, NewTotal, AssetSharesThousands, SourceUrl, ExchangeInfo, Role, Category) {
        super();
        this.Insider = Insider;
        this.NumShares = (NumShares | 0);
        this.Date = Date$;
        this.AvgPrice = AvgPrice;
        this.NewTotal = NewTotal;
        this.AssetSharesThousands = (AssetSharesThousands | 0);
        this.SourceUrl = SourceUrl;
        this.ExchangeInfo = ExchangeInfo;
        this.Role = Role;
        this.Category = (Category | 0);
    }
}

export function PostInsiderInfo_$reflection() {
    return record_type("Types.PostInsiderInfo", [], PostInsiderInfo, () => [["Insider", string_type], ["NumShares", int32_type], ["Date", string_type], ["AvgPrice", option_type(float64_type)], ["NewTotal", option_type(int32_type)], ["AssetSharesThousands", int32_type], ["SourceUrl", string_type], ["ExchangeInfo", option_type(InsiderTradeExchangeInfo_$reflection())], ["Role", string_type], ["Category", int32_type]]);
}

export class ShortEventPosition extends Record {
    constructor(InstitutionId, Institution, PrevNumShares, NewNumShares) {
        super();
        this.InstitutionId = (InstitutionId | 0);
        this.Institution = Institution;
        this.PrevNumShares = (PrevNumShares | 0);
        this.NewNumShares = (NewNumShares | 0);
    }
}

export function ShortEventPosition_$reflection() {
    return record_type("Types.ShortEventPosition", [], ShortEventPosition, () => [["InstitutionId", int32_type], ["Institution", string_type], ["PrevNumShares", int32_type], ["NewNumShares", int32_type]]);
}

export class PostShortInfo extends Record {
    constructor(NewPercentage, PrevPercentage, PrevNumShares, NewNumShares, PositionDate, Positions) {
        super();
        this.NewPercentage = (NewPercentage | 0);
        this.PrevPercentage = PrevPercentage;
        this.PrevNumShares = PrevNumShares;
        this.NewNumShares = (NewNumShares | 0);
        this.PositionDate = PositionDate;
        this.Positions = Positions;
    }
}

export function PostShortInfo_$reflection() {
    return record_type("Types.PostShortInfo", [], PostShortInfo, () => [["NewPercentage", int32_type], ["PrevPercentage", option_type(int32_type)], ["PrevNumShares", option_type(int32_type)], ["NewNumShares", int32_type], ["PositionDate", string_type], ["Positions", array_type(ShortEventPosition_$reflection())]]);
}

export class User extends Record {
    constructor(Id, Username, Official) {
        super();
        this.Id = (Id | 0);
        this.Username = Username;
        this.Official = Official;
    }
}

export function User_$reflection() {
    return record_type("Types.User", [], User, () => [["Id", int32_type], ["Username", string_type], ["Official", bool_type]]);
}

export class Post extends Record {
    constructor(Id, Type, Content, User, Published, AssetInfo, ShortInfo, InsiderInfo) {
        super();
        this.Id = (Id | 0);
        this.Type = Type;
        this.Content = Content;
        this.User = User;
        this.Published = Published;
        this.AssetInfo = AssetInfo;
        this.ShortInfo = ShortInfo;
        this.InsiderInfo = InsiderInfo;
    }
}

export function Post_$reflection() {
    return record_type("Types.Post", [], Post, () => [["Id", int32_type], ["Type", string_type], ["Content", string_type], ["User", User_$reflection()], ["Published", string_type], ["AssetInfo", option_type(anonRecord_type(["Market", string_type], ["Name", string_type], ["Ticker", string_type], ["Type", int32_type]))], ["ShortInfo", option_type(PostShortInfo_$reflection())], ["InsiderInfo", option_type(PostInsiderInfo_$reflection())]]);
}

export class PreOpenMeta extends Record {
    constructor(Date$, HasAccess) {
        super();
        this.Date = Date$;
        this.HasAccess = HasAccess;
    }
}

export function PreOpenMeta_$reflection() {
    return record_type("Types.PreOpenMeta", [], PreOpenMeta, () => [["Date", string_type], ["HasAccess", bool_type]]);
}

